import { render, staticRenderFns } from "./decorateDetail.vue?vue&type=template&id=9e36697a&scoped=true"
import script from "./decorateDetail.vue?vue&type=script&lang=js"
export * from "./decorateDetail.vue?vue&type=script&lang=js"
import style0 from "./decorateDetail.vue?vue&type=style&index=0&id=9e36697a&prod&lang=scss&scoped=true"
import style1 from "./decorateDetail.vue?vue&type=style&index=1&id=9e36697a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e36697a",
  null
  
)

export default component.exports